import { render } from "./BackAdvisor.vue?vue&type=template&id=29095d2c"
import script from "./BackAdvisor.vue?vue&type=script&lang=js"
export * from "./BackAdvisor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__